import {
  EnumOperatorEnrollmentsOnboardingStatus,
  OperatorWithStatus,
  PublicationStatusType,
} from "gql/generated";

/**
 * Operator status comes either from the PublicationStatus collection
 * OR the enrollment information for the organization
 * - We'll check the PublicationStatus first because those checks
 *   do not require looping over the enrollment data
 * @param operator
 * @param organization
 * @returns
 */
export const getOperatorStatus = (
  operator: OperatorWithStatus,
  organization?: string,
) => {
  // If for some reason the operator is not found, we'll return false for all statuses
  // This will fix Sentry error ID 7c37993d41694f39a495f31d24443b28
  if (!operator) {
    return {
      isNotInvited: false,
      isInvited: false,
      isInvitedAccepted: false,
      isNeedsApproval: false,
      isApproved: false,
      isUnpublished: false,
    };
  }

  const isApproved = operator.status === PublicationStatusType.Approved;

  const isNeedsApproval =
    !isApproved && operator.status === PublicationStatusType.NeedsApproval;

  const isUnpublished =
    !isApproved &&
    !isNeedsApproval &&
    operator.status === PublicationStatusType.Unpublished;

  const isNotInvited =
    !isApproved && !isNeedsApproval && !isUnpublished && operator.iasc === 0;

  let isInvited = false;
  let isInvitedAccepted = false;

  if (
    organization &&
    !isApproved &&
    !isNeedsApproval &&
    !isUnpublished &&
    !isNotInvited
  ) {
    const enrollment = operator.enrollments.find(
      enrollment => enrollment?.organization === organization,
    );

    // Removed the check for (!operator.status || operator.status === PublicationStatusType.Draft)
    // for isInvited and isInvitedAccepted because we'll only be in the IF statement if that is true
    isInvited =
      enrollment?.onboardingStatus !==
        EnumOperatorEnrollmentsOnboardingStatus.CompletedOnboarding &&
      enrollment?.organizationControlled === false;

    isInvitedAccepted =
      !isInvited &&
      enrollment?.onboardingStatus ===
        EnumOperatorEnrollmentsOnboardingStatus.CompletedOnboarding &&
      enrollment?.organizationControlled === false;
  }

  return {
    isNotInvited,
    isInvited,
    isInvitedAccepted,
    isNeedsApproval,
    isApproved,
    isUnpublished,
  };
};
